import { Trans } from 'react-i18next';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { Link, Paragraph } from '@sentara-health/optimahealth_web';
import { t } from 'i18next';

const AlternativeAddressDetails = () => {
  const { ssoEndPoints } = useContext(GlobalContext);

  return (
    <div data-testid="alternativeAddressDetails">
      <Paragraph
        text={t('profile.alternateAddress')}
        variant="bold"
        dataTestId={'alternateAddress'}
        className={` mt-md-0 mb-1`}
      />
      <Paragraph
        text={
          <Trans
            i18nKey={'profile.alternateAddressMessage'}
            components={{
              FormLink: (
                <Link
                  to={ssoEndPoints?.alternativeAddressForm || ''}
                  target="_blank"
                  className="text-decoration-underline"
                />
              ),
            }}
          />
        }
        variant="regular"
        className="pe-1 mb-0"
      />
    </div>
  );
};

export default AlternativeAddressDetails;
